<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1"></client-select>
            <admin-user-select :model="filterFormModel" attribute="adminUser" class="mr-1 mb-1"
                               :place-holder="$t('selectAdminUser')"></admin-user-select>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
                {value: null, text: $t('chooseType')},
                {value: 'new', text: $t('new')},
                {value: 'setup', text: $t('setup')},
                {value: 'user', text: $t('user')},
                {value: 'extend', text: $t('extend')},
                {value: 'upgrade', text: $t('upgrade')},
            ]"></form-select>
            <form-select :model="filterFormModel" attribute="role" class="mr-1 mb-1" :options="[
                {value: null, text: $t('chooseRole')},
                {value: 'sales', text: $t('sales')},
                {value: 'supervisor', text: $t('supervisor')},
                {value: 'manager', text: $t('manager')},
                {value: 'operationsManager', text: $t('operationsManager')},
            ]"></form-select>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('createTime')"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('adminUser') }}</div>
            <div class="col-lg-3">{{ $t('planOrderInfo') }}</div>
            <div class="col-lg-2">{{ $t('createTime') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p>
                <b class="c-smart-table__label">{{ $t('client') }}: </b>
                <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>
                <br>
                <label v-if="item.type === 'new'" class="badge badge-primary">{{ $t('new') }}</label>
                <label v-if="item.type === 'user'" class="badge badge-success">{{ $t('user') }}</label>
                <label v-if="item.type === 'extend'" class="badge badge-warning">{{ $t('extend') }}</label>
                <label v-if="item.type === 'upgrade'" class="badge badge-info">{{ $t('upgrade') }}</label>
                <label v-if="item.type === 'package'" class="badge badge-info">{{ $t('package') }}</label>
              </p>
            </div>
            <div class="col-lg-4">
              <p>
                <b>{{ $t('adminUser') }}:&nbsp;</b>
                <span>{{ item.adminUser.name }} ({{ item.adminUser.email }})</span>
              </p>
              <p>
                <b>{{ $t('role') }}: </b>
                <span>{{ $t(item.role) }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p v-if="item.planOrder">
                <b>{{ $t('planOrderType') }}: </b>
                <span>{{ $t(item.planOrder.type) }}</span>
              </p>
              <p v-if="item.planOrder">
                <b>{{ $t('planOrderValue') }}: </b>
                <span>{{ item.planOrder.total | numFormat }}</span>
              </p>
              <p v-if="item.planOrder &&item.planOrder.agencyCommission">
                <b>{{ $t('planOrderAgencyCommission') }}: </b>
                <span>{{ item.planOrder.agencyCommission | numFormat }}</span>
              </p>
              <p>
                <b>{{ $t('percent') }}: </b>
                <span>{{ item.percent ? item.percent : 0 }}%</span>
              </p>
              <p v-if="item.planOrder">
                <b>{{ $t('commissionAmount') }}: </b>
                <span>{{ item.percent ? item.percent * (item.planOrder.total - item.planOrder.agencyCommission) / 100 : 0 | numFormat }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <p>
                <b class="c-smart-table__label">{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length && !loading">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../components/ClientSelect";
import _ from 'lodash';
import TimeRangePicker from "@/components/TimeRangePicker";
import AdminUserSelect from "@/components/AdminUserSelect";

export default {
  components: {
    AdminUserSelect,
    TimeRangePicker,
    ClientSelect
  },
  mixins: [List],
  data: function () {
    return {
      service: '/commission',
      defaultFilterFormModel: {
        client: null,
        adminUser: null,
        type: null,
        role: null
      },
      autoLoad: true
    }
  },
  methods: {
    search: _.debounce(function () {
      this.init = false;
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
  },
  i18n: {
    messages: {
      en: {
        title: 'Commission detail',
        planOrderType: 'Plan order type',
        planOrderValue: 'Plan order value',
        adminUser: 'User',
        percent: 'Percent',
        commissionAmount: 'Commission amount',
        createTime: 'Create time',
        planOrderInfo: 'Plan order info',
        sales: 'Sales',
        supervisor: 'Supervisor',
        manager: 'Manager',
        account: 'Account',
        operationsManager: 'Operations manager',
        new: 'Buy new',
        user: 'Buy more user',
        upgrade: 'Upgrade',
        extend: 'Extend',
        chooseType: 'Choose order type',
        chooseRole: 'Choose commission type',
        init: 'Use the filter and press Search to see the result',
        selectAdminUser: 'Select user',
        setup: 'Setup',
        planOrderAgencyCommission: 'Agency commission'
      },
      vi: {
        title: 'Chi tiết hoa hồng',
        planOrderType: 'Loại đơn hàng',
        planOrderValue: 'Giá trị đơn hàng',
        adminUser: 'Nhân viên',
        percent: 'Phần trăm',
        commissionAmount: 'Giá trị hoa hồng',
        createTime: 'Tạo lúc',
        planOrderInfo: 'Thông tin đơn hàng',
        sales: 'Sales',
        supervisor: 'Trưởng nhóm',
        manager: 'Trưởng phòng',
        account: 'Account',
        operationsManager: 'TP vận hành',
        new: 'Mua mới',
        user: 'Mua thêm user',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        chooseType: 'Loại đơn hàng',
        chooseRole: 'Loại hoa hồng',
        init: 'Sử dụng bộ lọc và nhấn Tìm kiếm để hiển thị kết quả',
        selectAdminUser: 'Chọn nhân viên',
        setup: 'Cài đặt',
        planOrderAgencyCommission: 'Hoa hồng đại lý'
      }
    }
  }
}
</script>